import { useBreakpoint } from '@ocean/hooks'
import { layouts } from '@ocean/ui'
import { LayoutProps, ListItemLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import { Root, Wrapper, Sidebar, Header, Content, Footer } from './ListItemLayout.styled'

const { SectionLayout } = layouts

export type ListItemLayoutSegments = 'header' | 'content' | 'footer' | 'sidebar'
type InternalLayoutProps = LayoutProps<ListItemLayoutSegments>

export const ListItemSegment: React.FC<ListItemLayoutSegmentProps> = ({ children }) => (
  <>{children}</>
)

const ListItemLayout = ({ segments }: InternalLayoutProps) => {
  const isDesktop = useBreakpoint('sm')

  function renderLayout() {
    return (
      <Root>
        <Wrapper>
          {segments?.header && <Header>{segments.header}</Header>}
          {segments?.content && <Content>{segments.content}</Content>}
          {segments?.footer && <Footer>{segments.footer}</Footer>}
        </Wrapper>
        {segments?.sidebar && <Sidebar>{segments.sidebar}</Sidebar>}
      </Root>
    )
  }

  if (isDesktop) return renderLayout()

  return <SectionLayout>{renderLayout()}</SectionLayout>
}

export default withLayout(ListItemLayout)
